//#region Utils

import * as $ from 'jquery'
import * as _ from 'underscore'

//#endregion

import { DataProvider, ReferenceTypeComponent } from "../helpers"

import { OpFile, OpOperator, OpLocationEquipment } from "../models/core"
import { Enums } from "../models/common"
import { OpDashboard, ColumnInfo } from "../models/custom"
import { IReferenceType } from '../models/util/interfaces'
import { IndexedParamCacheStrategy } from './cache-strategies'
import { DataProviderListResult } from './data-provider.interfaces'

export class DataProviderOperator {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public deleteOperator = (opObj: OpOperator): JQueryPromise<void> => {
        return this.dataProvider.sendRequestWithSession('OpxDeleteOperator', { ToBeDeleted: opObj.toJSON() }, null)
    }

    public getDashboardConf = (idOperator: number, idDashboard: number = null): JQueryPromise<OpDashboard[]> => {
        return this.dataProvider
            .sendRequestWithSession("OpxGetOperatorDashboardConf", { IdOperator: idOperator, IdDashboard: idDashboard }, 'OpxGetOperatorDashboardConfResult')
            .then((result: any[]) => {
                return result.map((dashboardConfig: any) => new OpDashboard(dashboardConfig))
            })
    }

    public getFitterOperators(idOperator: number[] = null) {
        return this.dataProvider
            .sendRequestWithSession('OpxGetFitterOperators', { IdOperator: idOperator }, 'OpxGetFitterOperatorsResult')
            .then((response: any[]) => {
                return response.map((operatorObj: any) => new OpOperator(operatorObj))
            })
    }

    public getLastIdOperator = (): number => {
        return this.dataProvider.LocalStorage.getFromLocalStorage(Enums.SimaxLocalStorageKey.LastIdOperator, null)
    }

    public getLoggedOperatorLocal = (): OpOperator => {
        return this.dataProvider.LocalStorage.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.LoggedOperator)
    }

    public getLoggedOperator = (querryOnlyLocal: boolean = false): JQueryPromise<OpOperator> => {
        return this
            .getOperatorSettings(0, [Enums.SimaxOperatorSetting.LoggedOperator], false, querryOnlyLocal)
            .then(result => {
                if (result && result.length > 0)
                    return result[0]
                return null
            })
    }

    public getOperator = (idOperator: number): JQueryPromise<OpOperator> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetOperator', { IdOperator: idOperator }, 'OpxGetOperatorResult')
            .then((response: OpOperator) => {
                if (response != null) {
                    const operator: OpOperator = new OpOperator(response)

                    return OpOperator
                        .loadNavigationProperties(this.dataProvider, [operator])
                        .then((operators: OpOperator[]) => _.first(operators))
                }

                return null
            })
    }

    public getOperatorDepositoryContent = (idOperator: number, includeHistoricalData: boolean = false): JQueryPromise<OpLocationEquipment[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetOperatorDepositoryContent', { IdOperator: idOperator, includeHistoricalData }, 'OpxGetOperatorDepositoryContentResult')
            .then((data: any[]) => data.map(dataItem => new OpLocationEquipment(dataItem)))
    }

    public getOperatorDepositoryContentFilter = (idOperator: number, columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): JQueryPromise<DataProviderListResult<OpLocationEquipment>> => {
        return this.dataProvider.sendFilterRequestWithSession<OpLocationEquipment>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdLocationEquipment, 'OpxGetOperatorDepositoryContentFilter', 'OpxGetOperatorDepositoryContentFilterResult', { IdOperator: idOperator, OnlyCurrent: true })
    }

    public getOperatorFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpOperator>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdOperator, 'OpxOperatorFilter', 'OpxOperatorFilterResult')
    }

    public getOperatorPermissionReferenceObjectList = <TReferenceType extends IReferenceType>(referenceType: Enums.ReferenceType, referenceValues: any[], columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): JQueryPromise<TReferenceType[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetOperatorPermissionReferenceObjectList', {
                ReferenceType: referenceType,
                ReferenceValues: referenceValues,
                Columns: columns,
                PageNbr: pageNbr,
                PageSize: pageSize,
                CustomWhereClause: customWhereClause
            }, 'OpxGetOperatorPermissionReferenceObjectListResult')
            .then((result: any[]) => {
                if (_.isArray(result)) {
                    return result
                        .map((opObj: any) => ReferenceTypeComponent.createReferenceObject(referenceType, opObj) as TReferenceType)
                        .filter((reference: TReferenceType) => reference != null)
                }

                return null
            })
    }

    public getOperatorSettings = (idOperator: number, settings: Enums.SimaxOperatorSetting[], querryInterface: boolean = false, querryOnlyLocal: boolean = false, settingsSaveSkip: Enums.SimaxOperatorSetting[] = null): JQueryPromise<any[]> => {
        var deferred: JQueryDeferred<any[]> = $.Deferred<any[]>()

        if (!settings || settings.length == 0) {
            return deferred.resolve([]).promise()
        }

        var result: any[] = [settings.length]//Nalezy w odpowiedzi zachować kolejność opcji w jakiej pojawiły się w tabeli settings
        var settingTypesQuerryInterface: Enums.SimaxOperatorSetting[] = []
        var settingTypesLoaded: Enums.SimaxOperatorSetting[] = []
        settings.forEach(d => {
            if (querryInterface)
                settingTypesQuerryInterface.push(d)
            else {
                if (querryOnlyLocal || (this.dataProvider.LocalStorage.loggedOperatorSettings && this.dataProvider.LocalStorage.containsLoggedOperatorSetting(d)))
                    settingTypesLoaded.push(d)
                else
                    settingTypesQuerryInterface.push(d)
            }
        })
        if (settingTypesLoaded.length > 0) {
            settingTypesLoaded.forEach(s => {
                result[settings.indexOf(s)] = this.dataProvider.LocalStorage.getLoggedOperatorSetting(s)
            })
        }
        if (settingTypesQuerryInterface.length > 0) {
            this.requestOperatorSettings(idOperator, settingTypesQuerryInterface)
                .then(r => {
                    var loadedSettings: any[] = <any[]>r
                    if (loadedSettings && loadedSettings.length > 0) {
                        for (var i: number = 0; i < loadedSettings.length; i++) {

                            if (settingsSaveSkip == null || !_.contains(settingsSaveSkip, settingTypesQuerryInterface[i])) {
                                this.dataProvider.LocalStorage.saveLoggedOperatorSetting(settingTypesQuerryInterface[i], loadedSettings[i])
                                result[settings.indexOf(settingTypesQuerryInterface[i])] = this.dataProvider.LocalStorage.getLoggedOperatorSetting(settingTypesQuerryInterface[i])
                            }
                            else {
                                result[settings.indexOf(settingTypesQuerryInterface[i])] = loadedSettings[i]
                            }

                        }
                    }
                    deferred.resolve(result)
                })
        } else
            deferred.resolve(result)
        return deferred.promise()
    }

    private requestOperatorSettings(idOperator: number, operatorSettings: Enums.SimaxOperatorSetting[]): JQueryPromise<any> {
        const requestParams = { idOperator: idOperator, settings: operatorSettings }
        const cacheStrategy = new IndexedParamCacheStrategy<typeof requestParams>({
            getIndexedParams: (params) => {
                return params.settings
            },
            setIndexedParams: (params, cachedParams) => {
                params.settings = cachedParams
            },
        })

        return this.dataProvider.sendCachedRequestWithSession('OpxGetOperatorSettings', requestParams, 'OpxGetOperatorSettingsResult', cacheStrategy)
    }

    public saveOperator(operator: OpOperator): JQueryPromise<OpOperator> {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveOperator', { ToBeSaved: operator.toJSON() }, 'OpxSaveOperatorResult')
            .then((response: any) => {
                if (response != null) {
                    const operator: OpOperator = new OpOperator(response)

                    return OpOperator
                        .loadNavigationProperties(this.dataProvider, [operator])
                        .then((operators: OpOperator[]) => _.first(operators))
                }


                return null
            })
    }

    public saveOperatorLayoutSettings = (idOperator: number, files: OpFile[], logoutRequest: boolean, querryOnlyLocal: boolean = false) => {
        const deferred: JQueryDeferred<boolean> = $.Deferred<boolean>()

        if (files != null && files.length > 0) {
            this.dataProvider.LocalStorage.saveLoggedOperatorSetting(Enums.SimaxOperatorSetting.Layout, files, 0)

            if (!querryOnlyLocal) {
                this.dataProvider.
                    sendRequestWithSession('OpxSaveOperatorLayoutSettings', { idOperator: idOperator, settings: files, logoutRequest }, null)
                    .then(r => {
                        deferred.resolve(true)
                    })
                    .fail(() => {
                        deferred.resolve(false)
                    })
            }
        }
        else {
            deferred.resolve(false)
        }
        return deferred.promise()
    }

    public setLastIdOperator = (idOperator: number) => {
        this.dataProvider.LocalStorage.saveToLocalStorage(Enums.SimaxLocalStorageKey.LastIdOperator, idOperator, 0)
    }

    // Public Methods End
}